<template>
  <v-app-bar :elevation="2" color="#000000" :image="bgimage">
    <template v-slot:image>
      <v-img :gradient="gradientvalues"/>
    </template>
    <template v-slot:prepend>
      <v-app-bar-nav-icon @click="appevent.openSideMenu=!appevent.openSideMenu"></v-app-bar-nav-icon>
    </template>
    <v-app-bar-title class="bar-title" v-if="this.$route.path == '/dashboard/welcome'">Lynx Mobile</v-app-bar-title>
    <v-spacer></v-spacer>
    <v-btn icon v-if="this.$route.path != '/dashboard/welcome'">
      <v-icon @click="appevent.openSearchMenu=!appevent.openSearchMenu">mdi-magnify</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
import { AppEventsStore } from '@/stores'

export default {
  props: {
    titre: String,
    couleurFond: String
  },
  computed: {
    appevent: function () {
      return AppEventsStore()
    },
    gradientvalues: function () {
      // red
      let colors = 'white'
      switch (this.$route.path) {
        case '/dashboard/welcome':
          colors = 'to top right, rgba(80,80,80,.7), rgba(200,200,200,.7)'
          break
        case '/dashboard/cand':
          colors = 'to top right, rgba(90,122,90,.8), rgba(150,199,150,.8)'
          break
        case '/dashboard/cust':
          colors = 'to top right, rgba(90,90,122,.8), rgba(150,150,199,.8)'
          break
        case '/dashboard/opp':
          colors = 'to top right, rgba(122,90,90,.8), rgba(199,150,150,.8)'
          break
      }
      return colors
    },
    bgimage: function () {
      let image = ''
      switch (this.$route.path) {
        case '/dashboard/welcome':
          image = require('@IMG/feuilles.svg')
          break
        case '/dashboard/cand':
          image = require('@IMG/taureau_green.svg')
          break
        case '/dashboard/cust':
          image = require('@IMG/ours_blue.svg')
          break
        case '/dashboard/opp':
          image = require('@IMG/lynx_red.svg')
          break
      }
      return image
    }
  }
}
</script>

<style scoped>
.title-bar span {
  font-weight: bold;
}

</style>
